import { apiSlice } from "./apiSlice";

export const blogApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBlogCategories: builder.query({
      query: () => "/home/api/v1/blog/categories",
    }),
    getBlogList: builder.query({
      query: ({ category, page = 0, pageSize = 12 }) => {
        let url = `/home/api/v1/blog/list?page=${page}&pageSize=${pageSize}`;
        if (category) url += `&category=${category}`;
        return url;
      },
    }),
    getBlogDetail: builder.query({
      query: (slug) => `/home/api/v1/blog/detail/${slug}`,
    }),
    getRecommendedBlogs: builder.query({
      query: () => "/home/api/v1/blog/recommended",
    }),
  }),
});

export const {
  useGetBlogCategoriesQuery,
  useGetBlogListQuery,
  useGetBlogDetailQuery,
  useGetRecommendedBlogsQuery,
} = blogApiSlice;
